// scaleText.js — read the printed drawing scale from sheet text. A SUGGESTION only; the estimator confirms.
// Returns { label, ftPerUnit, count, multi, all:[{label, ftPerUnit, count}] } or null.
// ftPerUnit = feet per sheet unit (PDF point at scale 1).

const PT_PER_IN = 72;
const frac = (s) => { const t = s.trim(); if (t.includes("/")) { const [a, b] = t.split("/").map(Number); return b ? a / b : NaN; } return Number(t); };

export function detectScaleFromText(text) {
  const found = new Map();
  const add = (label, ftPerUnit) => {
    if (!(ftPerUnit > 0) || !isFinite(ftPerUnit)) return;
    const k = label.replace(/\s+/g, "");
    const e = found.get(k) || { label, ftPerUnit, count: 0 };
    e.count++; found.set(k, e);
  };
  for (const t of text) {
    const s = t.str.replace(/[’′]/g, "'").replace(/[”″]/g, '"');
    // architectural: 1/4" = 1'-0"   3/16"=1'-0"   1" = 1'-0"   1 1/2" = 1'-0"
    let m = s.match(/(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:\.\d+)?)\s*"\s*=\s*1\s*'\s*-?\s*0?\s*"?/);
    if (m) {
      const parts = m[1].trim().split(/\s+/);
      const inches = parts.length === 2 ? Number(parts[0]) + frac(parts[1]) : frac(parts[0]);
      if (inches > 0) add(`${m[1].trim()}" = 1'-0"`, 1 / (inches * PT_PER_IN));
      continue;
    }
    // engineering: 1" = 20'   1"=10'-0"
    m = s.match(/1\s*"\s*=\s*(\d+(?:\.\d+)?)\s*'/);
    if (m) { add(`1" = ${m[1]}'`, Number(m[1]) / PT_PER_IN); continue; }
    // metric: 1:50, 1:100 (paper mm → real)
    m = s.match(/(?:^|\s|SCALE:?\s*)1\s*:\s*(\d{1,4})(?!\d)/i);
    if (m) { const r = Number(m[1]); if (r >= 5 && r <= 2000) add(`1:${r}`, (25.4 / 72 / 304.8) * r); }
  }
  const all = [...found.values()].sort((a, b) => b.count - a.count);
  if (!all.length) return null;
  return { ...all[0], multi: all.length > 1, all };
}
